// extracted by mini-css-extract-plugin
export var projects_list = "projects-module--projects_list--1oPko";
export var project_section = "projects-module--project_section--3YMqU";
export var project = "projects-module--project--X9Vjn";
export var project_content = "projects-module--project_content--b6xbf";
export var project_tech = "projects-module--project_tech--vTB_g";
export var imageWrapper = "projects-module--imageWrapper--2OLd_";
export var project_subtitle = "projects-module--project_subtitle--1JVBK";
export var project_title = "projects-module--project_title--2kl6S";
export var project_descr = "projects-module--project_descr--3hUTF";
export var image = "projects-module--image--A3Bfu";